import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { TOOLBAR_COLORS } from "../constants";

interface TooltipShortcutProps {
    toolName: string;
    shortcutKey: string;
    label?: string;
    /** When placement is "right", the pill renders after the label. */
    placement?: "left" | "right" | "top" | "bottom";
}

export function TooltipShortcut({ toolName, shortcutKey, label, placement }: TooltipShortcutProps) {
    const { t } = useTranslation();
    const displayText = label ?? t(toolName);

    const pill =
        shortcutKey !== "" ? (
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    height: "16px",
                    padding: "0 6px",
                    backgroundColor: TOOLBAR_COLORS.TOOLTIP_PILL_BG,
                    borderRadius: "2px",
                    fontSize: "12px",
                    fontWeight: 600,
                    color: TOOLBAR_COLORS.TOOLTIP_TEXT,
                    lineHeight: "16px",
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                    boxSizing: "border-box",
                }}
            >
                {shortcutKey}
            </Box>
        ) : null;

    if (placement === "right") {
        return (
            <>
                {displayText}
                {pill}
            </>
        );
    }

    return (
        <>
            {pill}
            {displayText}
        </>
    );
}
